"use client";
import ProductPage from "@/components/ProductPage";
import { Check } from "lucide-react";
import ImageHero from "./hero.png";
import ImgTech from "./api.jpg";
import ImgResponsive from "./responsive.jpg";
import ImgApi from "./api.jpg";
import ImgAgile from "./hero.png";
import ImgSecurity from "./shield.jpg.png";
import ImageText from "@/components/ImageText";
import Section from "@/components/Section";

import React from "react";

export default function Software() {
  return (
    <ProductPage
      productName={"Softwareentwicklung & Anwendungsentwicklung"}
      hero={{
        title: "Maßgeschneiderte Softwareentwicklung",
        subtitle:
          "Individuelle Softwarelösungen, die Ihre Geschäftsprozesse optimieren und Ihr Unternehmen voranbringen.",
        buttonLeft: {
          title: "Unverbindliche Anfrage",
          href: "/support",
        },
        buttonRight: { title: "Kontakt aufnehmen", href: "/kontakt" },
        image: ImageHero,
        imageAlt: "Softwareentwicklung",
      }}
      details={{
        paragraphs: [],
      }}
      highlight={{
        image: ImageHero,
        bullets: [
          <>
            <strong>
              Front- und Backend-Technologien für leistungsstarke Anwendungen
            </strong>
          </>,
          <>
            <strong>Entwickeln sich mit Ihren Anforderungen</strong>
          </>,
          <>
            <strong>Transparenz im Entwicklungsprozess</strong>
          </>,
          <>
            <strong>Sicher und Datenschutzkonform</strong>
          </>,
          <>
            <strong>Nahtlose Einbindung</strong>
          </>,
          <>
            <strong>Agile Entwicklungsmöglichkeiten</strong>
          </>,
        ],
      }}
      beforeVideo={
        <Section className="bg-background text-foreground py-12 md:py-20">
          <ImageText
            imagePosition="right"
            imageSlot={
              <div className="relative overflow-hidden mt-15 rounded-2xl border border-black/10 bg-black shadow-sm h-100">
                <video className="h-full w-full object-cover" controls>
                  <source src="/VideoFürWebseite.mp4" type="video/mp4" />
                </video>
              </div>
            }
            title="Erfahrung, die Ihre Software stärkt"
          >
            <p className="text-slate-700 leading-relaxed">
              Mit über 25 Jahren Erfahrung in der Softwareentwicklung
              unterstützen wir Unternehmen im Einzelhandel, Großhandel und in
              der Buchhaltung dabei, ihre Abläufe zu digitalisieren und
              effizienter zu gestalten. Wir entwickeln Lösungen, die sich
              nahtlos in bestehende Prozesse integrieren und mit Ihrem
              Unternehmen wachsen.
            </p>
            <ul className="mt-4 space-y-2">
              {[
                "Individuell entwickelte Software statt Standardlösungen",
                "Branchenkenntnis aus Projekten im Handel und Rechnungswesen",
                "Flexible Anpassung an bestehende Systeme und Arbeitsabläufe",
                "Skalierbare Lösungen für zukünftiges Wachstum",
                "Effizientere Prozesse durch intelligente Automatisierung",
                "Persönliche Zusammenarbeit von der Planung bis zur Umsetzung",
              ].map((text, i) => (
                <li key={i} className="flex items-start gap-3 text-slate-700">
                  <Check
                    className="shrink-0 mt-1 text-brand-primary"
                    size={18}
                  />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </ImageText>
        </Section>
      }
      features={[
        {
          src: ImgTech,
          alt: "Moderne Frontend- und Backend-Technologien für individuelle Softwarelösungen",
          title: "State-of-the-Art Technologien für maximale Performance",
          desc: "Wir entwickeln leistungsstarke Anwendungen mit modernen Frontend- und Backend-Technologien.",
        },
        {
          src: ImgResponsive,
          alt: "Responsive und mobileoptimierte Softwarelösungen für jedes Gerät",
          title: "Optimiert für Desktop, Tablet & Smartphone",
          desc: "Unsere Software ist vollständig responsive und ermöglicht effizientes Arbeiten auf allen Endgeräten.",
        },
        {
          src: ImgApi,
          alt: "API-Schnittstellen und Integration bestehender Systeme in individuelle Software",
          title: "Nahtlose Integration bestehender Systeme",
          desc: "Wir verbinden neue Anwendungen über APIs mit Ihren bestehenden Systemen – sicher und zuverlässig.",
        },
        {
          src: ImgAgile,
          alt: "Agile Softwareentwicklung mit kurzen Iterationen und schnellem Feedback",
          title: "Agile Entwicklung für schnelle Ergebnisse",
          desc: "Durch agile Methoden liefern wir Ergebnisse in kurzen Zyklen und reagieren flexibel auf Ihr Feedback.",
        },
        {
          src: ImgSecurity,
          alt: "Sichere und wartbare Softwarearchitektur mit Fokus auf Datenschutz",
          title: "Sichere & wartbare Softwarearchitektur",
          desc: "Ihre Daten sind bei uns geschützt – mit sicherer Architektur, Datenschutz und langfristiger Wartbarkeit.",
        },
      ]}
      faqs={[
        {
          q: "Was unterscheidet Ihre Softwarelösungen von Standardprodukten?",
          a: "Unsere Software wird individuell auf Ihre Geschäftsprozesse abgestimmt. Statt Standardlösungen „von der Stange entwickeln wir Anwendungen, die exakt zu Ihren Anforderungen passen – effizient, flexibel und zukunftssicher.",
        },
        {
          q: "Für welche Branchen entwickeln Sie Software?",
          a: "Wir verfügen über langjährige Erfahrung insbesondere im Einzelhandel, Großhandel und in der Buchhaltung. Grundsätzlich sind unsere Lösungen aber branchenübergreifend anpassbar – sprechen Sie uns gerne mit Ihren individuellen Anforderungen an.",
        },
        {
          q: "Welche Technologien verwenden Sie?",
          a: "Wir setzen auf State-of-the-Art Frontend- und Backend-Technologien, responsive Designs für mobile Endgeräte sowie moderne API-Schnittstellen zur Integration bestehender Systeme. Dabei legen wir besonderen Wert auf Sicherheit, Datenschutz und wartbare Architektur.",
        },
        {
          q: "Wie läuft ein typisches Softwareprojekt bei Ihnen ab?",
          a: "Wir arbeiten agil – das bedeutet kurze Entwicklungszyklen, regelmäßiges Feedback und transparente Kommunikation. So bleiben Sie jederzeit im Prozess eingebunden und können aktiv mitgestalten.",
        },
        {
          q: "Bieten Sie auch Support und Wartung nach Projektabschluss an?",
          a: "Ja. Wir verstehen uns als langfristiger Partner und bieten kontinuierliche Weiterentwicklung, Updates und persönlichen Support an, um Ihre Software stets aktuell und leistungsfähig zu halten.",
        },
        {
          q: "Wie flexibel sind Ihre Lösungen bei zukünftigen Erweiterungen?",
          a: "Unsere Anwendungen sind modular aufgebaut und lassen sich jederzeit an veränderte Anforderungen anpassen – ob neue Funktionen, Schnittstellen oder Benutzergruppen. Ihre Software wächst mit Ihrem Unternehmen.",
        },
        {
          q: "Können bestehende Systeme integriert werden?",
          a: "Ja, über API-Schnittstellen können wir bestehende Systeme und Datenquellen nahtlos einbinden. So bleiben Ihre bisherigen Investitionen erhalten und Sie profitieren dennoch von einer modernen Gesamtlösung.",
        },
        {
          q: "Welche Vorteile habe ich durch eine maßgeschneiderte Software?",
          a: "Sie erhalten eine Lösung, die exakt auf Ihre Prozesse abgestimmt ist – ohne überflüssige Funktionen, dafür mit maximaler Effizienz, einfacher Bedienung und klarer Kostenstruktur.",
        },
        {
          q: "Wie stellen Sie Datenschutz und Sicherheit sicher?",
          a: "Wir entwickeln nach aktuellen Sicherheitsstandards und achten auf verschlüsselte Datenübertragung, zugriffsbasierte Berechtigungen und regelmäßige Sicherheitsupdates. Ihre Daten bleiben jederzeit geschützt.",
        },
        {
          q: "Welche typischen Einsatzbereiche decken Sie ab?",
          a: "Unsere Softwarelösungen unterstützen den Einzelhandel & POS mit Funktionen für Kassensysteme, Kundenmanagement, Verkaufsstatistiken und Inventur – auch mobil – sowie den Großhandel & die Warenwirtschaft mit effizienten Tools für Lieferkettenmanagement, Bestandsführung, Lagerlogistik und standortübergreifende Prozesse.",
        },
      ]}
    />
  );
}
